
import React from "react";
import { UnstiledField } from "./Inputs";
import { Field } from "redux-form";
import { Combobox } from "react-widgets";

const AddressField = ({ input, label, change, isSelected, defValue, onAddressSelected, disabled, fetchAddresses, customList, meta: { touched, error, warning } }) => (
    <div autoComplete='none'>
        
        {label && <label className='control-label'>{label}</label>}
        <Combobox
            data={customList}
            placeholder="Адрес"
            defaultValue={input.value}
            value={defValue ? defValue : input.value}
            disabled={disabled}
            onSelect={(e) => {
                isSelected = true;
                change("AddressError", null);
                onAddressSelected(e);
            }}
            onChange={(e) => {
                input.onChange(e);
                if (!isSelected)
                    change("AddressError", '*Выберите адрес из выпадающего списка');
                if (fetchAddresses) {
                    fetchAddresses(e);
                }
                isSelected = false;
                touched = true;
            }
            }
        />
        {(error && <span style={{ color: 'red', marginLeft: '5px' }}>{error}</span>)}
    </div>
);

export function AddressEdit({ editLock, defaultAddress, fetchAddressesAction, change, fetchedAddresses, showAdditionalFields, geoAddressName }) {
    const addresses = fetchedAddresses && fetchedAddresses.addresses.length > 0 ? 
        fetchedAddresses.addresses.map(a => { return { address: a.Name, lat: a.Latitude, lon: a.Longitude } } ) : [];
        const onAddressSelected = (address) => {
            const addr = addresses.find(a => a.address === address);
            const lat = addr !== undefined ? addr.lat : 0;
            const lon = addr !== undefined ? addr.lon : 0;
            change(geoAddressName, { X: lon, Y: lat});
        }
    return (
        <div style={{ paddingBottom: '5%', paddingRight: '15px', paddingLeft: '15px' }}>
            <div className="row">
                <div className="col-md-12">
                    <Field name='Address' defValue={defaultAddress} label='Адрес' component={AddressField} disabled={editLock}
                        change={change} onAddressSelected={onAddressSelected} fetchAddresses={fetchAddressesAction} customList={addresses.map(a => a.address)} />
                </div>
            </div>
            {showAdditionalFields &&
                <div className="row" >
                    <div className="col-md-3">
                        <Field name='Flat' label='Квартира' component={UnstiledField} disabled={editLock} />
                    </div>
                    <div className="col-md-3">
                        <Field name='Entrance' label='Подъезд' component={UnstiledField} disabled={editLock} />
                    </div>
                    <div className="col-md-3">
                        <Field name='Floor' label='Этаж' component={UnstiledField} disabled={editLock} />
                    </div>
                    <div className="col-md-3">
                        <Field name='IntercomCode' label='Код домофона' component={UnstiledField} disabled={editLock} />
                    </div>
                </div>}
        </div>
    )
}

AddressEdit.defaultProps = {
    editLock: false,
    showAdditionalFields: true
};


// WEBPACK FOOTER //
// ./src/components/common/AddressEdit.jsx